import React from 'react';
import PropTypes from 'prop-types';

 // Current version of react-table 7, which requires alot of changes to migrate to
 // https://github.com/tannerlinsley/react-table/tree/v6.11.4
import ReactTable from 'react-table';

 // TODO: The data can be accessible via context - https://reactjs.org/docs/context.html
import { 
    getReturnsByYear, 
    getAnnualizedReturns, 
    getStandardDeviation, 
    getTotalReturns,
    getFormattedPercent,
    getFormattedCurrency,
    getFormattedStandardDeviation,
 } from './utils';

import 'react-table/react-table.css';
import './IndexCompareTable.css'

function IndexCompareTable({availableIndexes, startYear, endYear}) {
    const matrixFiles = Object.keys(availableIndexes).map((key) => {
        return {
            value: key,
            label: availableIndexes[key].meta.name
        };
    });
    const tableData = matrixFiles.map(({value, label}) => {
        console.log(label);
        const currentMatrix = availableIndexes[value];
        const chartData = getReturnsByYear(currentMatrix, {startYear, endYear});
        const growthOfDollar = chartData.length === 0 ? NaN : chartData[chartData.length - 1].growthOfDollar;
        return {
            asset_classs: label,
            annualized_return: getAnnualizedReturns(chartData),
            standard_deviation: getStandardDeviation(chartData),
            total_returns: getTotalReturns(chartData),
            dollar_growth: growthOfDollar,
        }
    });
    return (
        <React.Fragment>
            <ReactTable
                data={tableData}
                columns={[
                    {
                        Header: 'Asset Class',
                        accessor: 'asset_classs',
                        className: '',
                        minWidth: 300
                    },
                    {
                        Header: 'Annualized Return',
                        accessor: 'annualized_return',
                        className: '',
                        Cell: ({value}) => <React.Fragment>{getFormattedPercent(value)}</React.Fragment>,
                    },
                    {
                        Header: 'Standard Deviation',
                        accessor: 'standard_deviation',
                        className: '',
                        Cell: ({value}) => <React.Fragment>{getFormattedStandardDeviation(value)}</React.Fragment>,
                    },
                    {
                        Header: 'Total Return',
                        accessor: 'total_returns',
                        className: '',
                        Cell: ({value}) => <React.Fragment>{getFormattedPercent(value)}</React.Fragment>,
                    },
                    {
                        Header: 'Growth of $1',
                        accessor: 'dollar_growth',
                        className: '',
                        Cell: ({value}) => <React.Fragment>{getFormattedCurrency(value)}</React.Fragment>,
                    }
                ]}
                style={{
                     // This will force the table body to overflow and scroll, since there is not enough room
                    height: "400px"
                }}
                showPagination={false}
                className="-striped -highlight"
                defaultPageSize={tableData.length}
            />
        </React.Fragment>
    )
}

IndexCompareTable.propTypes = {
    availableIndexes: PropTypes.any.isRequired, // TODO: define shape
    startYear: PropTypes.number.isRequired,
    endYear: PropTypes.number.isRequired,
}

export default IndexCompareTable

